<template>
  <div class="columns is-multiline signup-list">
    <signup-league-detail v-for="league in season.leagues" :key="league.id" :league="league" :season="season"></signup-league-detail>
    <signup-camp-detail v-for="camp in season.camps" :key="camp.id + 10000" :camp="camp" :season="season"></signup-camp-detail>
  </div>
</template>

<script>
import SignupLeagueDetail from '@/components/SignupLeagueDetail.vue';
import SignupCampDetail from '@/components/SignupCampDetail.vue';

export default {
  name: 'SignupList',
  components: {
    SignupLeagueDetail,
    SignupCampDetail
  },
  props: {
    season: {
      type: Object,
      required: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.signup-list {
  margin-right: 0.75rem;
  margin-left: 0.75rem;
}
</style>